import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/main.css'

import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'bootstrap-icons/font/bootstrap-icons.min.css'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import sweetalertMixin from './services/mix/sweetalert-mix'

import VueClipboard from 'vue3-clipboard'

import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import '@vuepic/vue-datepicker/dist/main.css';

import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';

import { MaskInput } from "vue-mask-next";

import VueDatePicker from '@vuepic/vue-datepicker';

const app = createApp(App);
app.use(store)
app.use(router)
app.component('VueDatePicker', VueDatePicker)
app.component("MaskInput", MaskInput);
app.use(SimpleTypeahead);
app.use(VueSweetalert2)
app.mixin(sweetalertMixin);
app.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
})
app.component("v-select", VueSelect)
app.mount('#app')
